import { useSidebarOpenState } from '@backstage/core-components';
import { makeStyles, Button, Box } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const useStyles = makeStyles(theme => ({
  expandButton: {
    background: 'none',
    border: 'none',
    color: theme.palette.navigation.color,
    width: '100%',
    cursor: 'pointer',
    position: 'relative',
    height: 48,
  },
  arrows: {
    position: 'absolute',
    right: 10,
  },
  iconContainer: {
    display: 'flex',
    position: 'relative',
    width: '100%',
  },
  arrow1: {
    right: '6px',
    position: 'absolute',
  },
}));

const DoubleArrowLeft = () => {
  const classes = useStyles();
  return (
    <Box className={classes.iconContainer}>
      <Box className={classes.arrow1}>
        <ArrowBackIosIcon style={{ fontSize: '12px' }} />
      </Box>
      <Box>
        <ArrowBackIosIcon style={{ fontSize: '12px' }} />
      </Box>
    </Box>
  );
};

const DoubleArrowRight = () => {
  const classes = useStyles();
  return (
    <Box className={classes.iconContainer}>
      <Box className={classes.arrow1}>
        <ArrowForwardIosIcon style={{ fontSize: '12px' }} />
      </Box>
      <Box>
        <ArrowForwardIosIcon style={{ fontSize: '12px' }} />
      </Box>
    </Box>
  );
};

/**
 * Custom SidebarExpandButton that stays visible at all screen widths.
 *
 * The default @backstage/core-components SidebarExpandButton hides itself
 * on screens narrower than the "md" breakpoint (960 px), which prevents
 * users from collapsing/expanding the sidebar on smaller monitors.
 *
 * This is a 1:1 replica of the original — same icons, same styles — minus
 * the media-query that removes it.
 */
export const SidebarExpandButton = () => {
  const classes = useStyles();
  const { isOpen, setOpen } = useSidebarOpenState();

  return (
    <Button
      role="button"
      onClick={() => setOpen(!isOpen)}
      className={classes.expandButton}
      aria-label="Expand Sidebar"
      data-testid="sidebar-expand-button"
    >
      <Box className={classes.arrows}>
        {isOpen ? <DoubleArrowLeft /> : <DoubleArrowRight />}
      </Box>
    </Button>
  );
};
